import type { ProductsContext } from "@/lib/api/generated/casedb";
import type { CaseReviewCollectionApi } from "../../shared/hooks/useCaseReview";

const CODING_IDENTITY_FIELDS = new Set([
  "product_name", "generic_name", "trade_name", "drug_code", "product_type", "product_role",
]);
const SOURCE_LABELS = {
  COMPANY_CONFIGURATION: "Loaded from product configuration",
  WHO_DD: "WHO-DD",
} as const;

/** Hide attribution while the facts it describes are being edited. */
export function useProductCodingSource(api: CaseReviewCollectionApi, sectionContext: unknown): string | null {
  const selected = api.rows.find(row => row.recordId === api.selectedId);
  if (!selected) return null;
  if (api.dirty(selected.recordId).some(key => CODING_IDENTITY_FIELDS.has(key))) return null;
  const context = sectionContext as ProductsContext | undefined;
  const source = context?.products?.find(row => row.record_id === selected.recordId)?.coding_source;
  return source ? SOURCE_LABELS[source] ?? null : null;
}
